// extracted by mini-css-extract-plugin
export var box = "Markup-module--box--d54a6";
export var box_md = "Markup-module--box_md--39438";
export var box_xmd = "Markup-module--box_xmd--9661d";
export var box_flex = "Markup-module--box_flex--260af";
export var box_lg = "Markup-module--box_lg--410a7";
export var box_sm = "Markup-module--box_sm--bacef";
export var box_outer = "Markup-module--box_outer--e2c64";
export var box_whiteBg = "Markup-module--box_white-bg--0cdb6";
export var box_noMarginBottom = "Markup-module--box_no-margin-bottom--d2149";
export var box_noPadding = "Markup-module--box_no-padding--81794";
export var box_outerGray = "Markup-module--box_outer-gray--5683c";
export var box_dark = "Markup-module--box_dark--79e64";
export var box_zIndex = "Markup-module--box_z-index--1684d";
export var box_zIndex6 = "Markup-module--box_z-index-6--8c14d";
export var box_eventsWithLine = "Markup-module--box_events-with-line--6a8f9";
export var box_featuresAo = "Markup-module--box_features-ao--9f625";
export var box_verticalPaddings = "Markup-module--box_vertical-paddings--32f5f";
export var clearP = "Markup-module--clearP--d9edb";
export var clearP_vc = "Markup-module--clearP_vc--620b4";
export var markup = "Markup-module--markup--de45b";
export var fadeInAnimation = "Markup-module--fadeInAnimation--2affb";
export var placeHolderShimmer = "Markup-module--placeHolderShimmer--a4279";